module.exports = __webpack_public_path__ + "img/jo1.35ac095f.png";